import _styled from "@emotion/styled-base";
var _excluded = ["multiline", "valid", "icon", "iconPlacement", "innerRef"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import { css } from "@emotion/core";
import shouldForwardProp from "@styled-system/should-forward-prop";
import * as React from "react";
import { borderRadius } from "styled-system";
import tinycolor from "tinycolor2";
import Box from "./Box";
import { allProps, emRhythm, remRhythm } from "./css";
import { extractStyledSystemProps, forwardInnerRef } from "./utils";
import { jsx as ___EmotionJSX } from "@emotion/core";

var StyledInput = /*#__PURE__*/_styled("input", {
  shouldForwardProp: shouldForwardProp,
  target: "e1chu76m0"
})(function (_ref) {
  var theme = _ref.theme,
      gray = _ref.gray;
  var borderColor = theme.colors.rule;
  var backgroundColor = gray ? theme.colors.grays[25] : theme.colors.white;
  return /*#__PURE__*/css("label:base;width:100%;padding:", emRhythm(1 / 4), " ", emRhythm(3 / 8), ";line-height:", remRhythm(3 / 4), ";min-height:calc(", remRhythm(1 + 1 / 4), " + 2px);border:1px solid ", borderColor, ";border-radius:", theme.radii.md, ";color:", theme.colors.heading, ";background:", backgroundColor, ";box-shadow:inset 0 1px 2px ", borderColor, ";outline:none;transition-timing-function:ease-out;transition-duration:500ms;transition-property:background-color,border-color,color,box-shadow;&::placeholder{color:", theme.colors.muted, ";}&:hover{border-color:", tinycolor(borderColor).darken(15).toString(), ";transition-duration:200ms;}&[aria-invalid=\"false\"]{border-color:", theme.colors.success, ";}&[aria-invalid=\"true\"]{border-color:", theme.colors.red, ";box-shadow:inset 0 1px 2px ", borderColor, ",0px 0px 1px 1px ", tinycolor(theme.colors.redHover).setAlpha(0.5).toString(), ";}&:focus{border-color:", theme.colors.blueHover, ";box-shadow:inset 0 1px 2px ", borderColor, ",0px 0px 1px 1px ", tinycolor(theme.colors.blueHover).setAlpha(0.5).toString(), ";transition-duration:200ms;}&:disabled{color:", tinycolor(theme.colors.text).lighten(10).toString(), ";cursor:default;cursor:not-allowed;background:", tinycolor(backgroundColor).darken(5).toString(), ";border-color:", borderColor, ";box-shadow:none;-webkit-text-fill-color:", tinycolor(theme.colors.text).lighten(10).toString(), ";opacity:1;}");
}, function (props) {
  return props.hasIcon && (props.iconPlacement === "left" ? /*#__PURE__*/css("label:with-left-icon;padding-left:", emRhythm(1.375), ";") : /*#__PURE__*/css("label:with-right-icon;padding-right:", emRhythm(1.375), ";"));
}, borderRadius);

var StyledTextArea = StyledInput.withComponent("textarea", {
  target: "e1chu76m1"
});
StyledTextArea.displayName = "StyledTextArea";

var Input = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Input, _React$Component);

  function Input() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Input.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        multiline = _this$props.multiline,
        valid = _this$props.valid,
        iconElement = _this$props.icon,
        iconPlacement = _this$props.iconPlacement,
        innerRef = _this$props.innerRef,
        props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var _extractStyledSystemP = extractStyledSystemProps(props, allProps),
        boxProps = _extractStyledSystemP[0],
        inputProps = _extractStyledSystemP[1];

    var InputComponent = multiline ? StyledTextArea : StyledInput;
    var ariaInvalid;

    if (valid != null) {
      ariaInvalid = valid ? "false" : "true";
    }

    var inputNode = ___EmotionJSX(InputComponent, _extends({
      key: "input",
      hasIcon: iconElement !== undefined,
      iconPlacement: iconPlacement,
      "aria-invalid": ariaInvalid // @ts-ignore: Figure out how to type this
      ,
      ref: innerRef
    }, inputProps));

    var children = [inputNode];

    if (iconElement !== undefined) {
      var icon = React.cloneElement(iconElement, {
        size: "1em"
      });
      var left;
      var right;

      if (iconPlacement === "left") {
        left = emRhythm(0.375);
      } else {
        right = emRhythm(0.375);
      }

      var iconNode = ___EmotionJSX(Box, {
        key: "icon",
        textColor: "muted",
        position: "absolute",
        top: emRhythm(0.25),
        left: left,
        right: right
      }, icon);

      children.push(iconNode);
    }

    return ___EmotionJSX(Box, _extends({
      position: "relative"
    }, boxProps), children);
  };

  return Input;
}(React.Component);

Input.defaultProps = {
  multiline: false,
  iconPlacement: "left",
  disabled: false,
  gray: false
};
var InputWithRef = forwardInnerRef(Input);
export default InputWithRef;